module.exports = __webpack_public_path__ + "img/08_WebFlow_11-1.42f3376b.svg";